import React from 'react';
import {Lightbulb} from 'lucide-react';
import Bot from './Bot.svg';

// Right-hand panel of each wizard step: illustration plus a short tip
const StepAside = ({title, children}: { title: string, children: React.ReactNode }) => {
    return (
        <aside className="StepLayout__right">
            <img src={Bot} alt=""/>
            <div className="StepLayout__tip">
                <span className="StepLayout__tipTitle"><Lightbulb size={15}/> {title}</span>
                <div className="StepLayout__tipBody">{children}</div>
            </div>
        </aside>
    );
};

export default StepAside;
